import React, { useEffect, useRef, useState } from 'react';

/**
 * Envolve qualquer conteúdo e aplica um fade/slide suave quando ele entra
 * na viewport. Sem dependências externas — usa IntersectionObserver.
 * Respeita prefers-reduced-motion via CSS (.reveal em index.css).
 */
const Reveal = ({ children, as: Tag = 'div', className = '', delay = 0, ...rest }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'is-visible' : ''} ${className}`.trim()}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
